import React from 'react';


export default props => (
    <div className="alert alert-danger" role="alert">
        <span className="text text-justity">{props.message}</span>
    </div>
)